// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export const WEB_TEXT: string = 'web';
export const SMS_TEXT: string = 'sms';
